import { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';

import ProfileMenu from './ProfileMenu';
import Notification from '../../../components/Notification';
import { LightTooltip } from '../../../components/AppTooltip';
import Theme from '../../../layout/Theme';
import { ROUTES } from '../../../constants/routes';

const RightHeader = ({ isDarkMode, accountInformationData }) => {
  const handleSetDarkMode = () => {
    window.localStorage.setItem('dark', !isDarkMode);
    const htmlRoot = document.querySelector('html');
    htmlRoot.classList.toggle('dark');
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const getTooltipContent = () => {
    if (!accountInformationData) {
      return null;
    }

    return (
      <div className="text-sm text-black dark:text-white text-left ml-2 hidden lg:block">
        <div className="w-full">{accountInformationData.fullName}</div>
        <div
          className="w-full text-xs"
          data-userid={accountInformationData.userId}
        >
          A{accountInformationData.userId}
        </div>
      </div>
    );
  };

  return (
    <ul className="flex items-center flex-shrink-0 space-x-1 lg:space-x-5">
      {accountInformationData && (
        <>
          <li className="relative pr-2 inline-flex">
            <Theme>
              <Notification />
            </Theme>
          </li>
          <li className="relative">
            <LightTooltip title={getTooltipContent()}>
              <button
                className="align-middle focus:shadow-outline-purple focus:outline-none flex items-center"
                onClick={handleClick}
              >
                <span className="object-cover w-8 h-8 rounded-full flex justify-center items-center bg-primary-main text-white">
                  {accountInformationData.textAvatar}
                </span>
                <input
                  type="hidden"
                  id="userId"
                  value={accountInformationData.userId}
                />
              </button>
            </LightTooltip>
            <ProfileMenu
              anchorEl={anchorEl}
              setAnchorEl={setAnchorEl}
              accountInformationData={accountInformationData}
            />
          </li>
        </>
      )}
      {!accountInformationData && (
        <li className="relative items-center flex">
          <a
            href={ROUTES.login}
            className="hidden sm:block text-sm hover:underline transition ease-in-out duration-200 text-primary-main btn-login-header"
          >
            Đăng nhập
          </a>
          <span className="hidden sm:block">&nbsp;|&nbsp;</span>

          <a
            href={ROUTES.signup}
            className="hidden sm:block text-sm hover:underline transition ease-in-out duration-200 text-primary-main btn-register-header"
          >
            Đăng ký
          </a>
        </li>
      )}
    </ul>
  );
};

export default RightHeader;
